import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { AnalisesGerenteProjeto } from '../models/analises-gerente-projeto.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnalisesGerenteProjetoService extends BaseService<AnalisesGerenteProjeto> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/analises-gerente';
  }

  public getOptions(id: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/getOptions/${id}`, { headers: this.headers });
  }
}
